import { defineMessages } from 'react-intl';

export default defineMessages({
  errorHeader: {
    id: 'app.containers.Error.errorHeader',
    defaultMessage: 'Ops! Algo deu errado',
  },
  errorDescription: {
    id: 'app.containers.Error.errorDescription',
    defaultMessage:
      'Encontramos um erro inesperado. Tente novamente em alguns instantes.',
  },
  back: {
    id: 'app.container.Error.back',
    defaultMessage: 'Voltar para página inicial',
  },
});
